import { z } from "zod";

export const RECONCILIATION_TYPES = ["PAYMENT", "TRANSFER", "ORPHAN", "ALL"] as const;
export type ReconciliationType = (typeof RECONCILIATION_TYPES)[number];

export const ISSUE_STATUSES = ["OPEN", "RESOLVED"] as const;
export type IssueStatus = (typeof ISSUE_STATUSES)[number];
export type IssueStatusFilter = "" | IssueStatus;

function isCalendarDate(value: string): boolean {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year
    && date.getUTCMonth() === month - 1
    && date.getUTCDate() === day;
}

export const reconciliationRunFormSchema = z.object({
  providerConfigurationId: z.string()
    .regex(/^\d+$/, "Provider 설정을 선택해 주세요.")
    .refine((value) => Number.isSafeInteger(Number(value)) && Number(value) > 0, "Provider 설정을 선택해 주세요."),
  type: z.enum(RECONCILIATION_TYPES),
  businessDate: z.string().refine(isCalendarDate, "유효한 기준일을 입력해 주세요."),
});
export type ReconciliationRunFormValues = z.infer<typeof reconciliationRunFormSchema>;

export const reconciliationResolutionSchema = z.object({
  memo: z.string().trim().min(1, "해결 메모를 입력해 주세요.").max(2_000, "해결 메모는 2,000자 이하로 입력해 주세요."),
});
export type ReconciliationResolutionValues = z.infer<typeof reconciliationResolutionSchema>;

export function parseIssueStatus(value: string | null): IssueStatusFilter {
  return ISSUE_STATUSES.includes(value as IssueStatus) ? value as IssueStatus : "";
}

export function parseReconciliationId(value: string | null): number | undefined {
  if (!value || !/^\d+$/.test(value)) return undefined;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined;
}
